export const useBackToManageJobs = () => {
  if (window.history.state?.back != null) {
    useRouter().back();
    return;
  }

  return `/manage-jobs/active`;
};
